import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (document.title) {
        const event = new Event("helmetUpdate");
        document.dispatchEvent(event);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);
};
